export default {
    EXOS_STAFF_NO: '员工号',
    EXOS_STAFF_BADGE_NO: '员工卡号',
    EXOS_STAFF_FULL_NAME: '员工姓名'
};
